import { Landmark } from './landmark.interface';

export const Landmarks: Landmark[] = [
  {
    code: 'caseta',
    name: 'Caseta',
    description: ''
  },
  {
    code: 'bellota',
    name: 'Museo Bellota / C.A.V.',
    description: 'Edificio principal de administración de Chipinque y Centro de Atención a Visitantes.'
  },
  {
    code: 'canoas',
    name: 'Canoas',
    description: ''
  },
  {
    code: 'explanada',
    name: 'Explanada',
    description: ''
  },
  {
    code: 'meseta',
    name: 'Meseta',
    description: ''
  },
  {
    code: 'hotel',
    name: 'Hotel',
    description: ''
  },
  {
    code: 'casa-general',
    name: 'Casa del Gral. Almazán',
    description: ''
  },
  {
    code: 'puerto-aire',
    name: 'Puerto del Aire',
    description: ''
  },
  {
    code: 'pinal',
    name: 'Pinal',
    description: ''
  },
  {
    code: 'epazote',
    name: 'Mesa del Epazote',
    description: ''
  }
];



// WEBPACK FOOTER //
// /Users/mundofr/GitHub/Angle/ChipinqueTrails/src/app/landmarks.data.ts